import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { getApi, ApiResponse } from 'services/_sgu';
import { CHANNEL } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaMunicipiosRequest } from './types';

// ACTIONS
import {
	consultaMunicipiosSuccess,
	consultaMunicipiosFailure,
} from './actions';

function* consultaMunicipios(request: ReducerAction) {
	const { payload }: { payload: ConsultaMunicipiosRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		`domain-service/${CHANNEL}/municipio`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaMunicipiosSuccess(response));
	} else if (response.error) {
		yield put(consultaMunicipiosFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTA_MUNICIPIOS_REQUEST, consultaMunicipios),
]);
